import ElementPage from "../../Elements";

// pages/CancellationRefundPolicy.jsx
export default function CancellationRefundPolicy() {
  return (
    <>
      <div style={styles.container} className="py-2">
        <div className="jtext-justify" style={{ fontFamily: "serif" }}>
          <h6 className="mt-1" style={{ color: "#FF4F00" }}>
            Refund & Cancellation Policy
          </h6>
          <p className="text-gray-700 fs-6 mb-0">
            This policy is issued by Khunkhaar Meldi Maa Bareja Trust.
          </p>
          <b className="text-gray-700 fs-6">1. No Refund Policy</b>
          <p className="mb-2 text-gray-600">
            All payments made on khunkhaarmeldimaabareja.com are final and
            non-refundable.
          </p>

          <b className="text-gray-700 fs-6">2. Devotional Nature</b>
          <p className="mb-2 text-gray-600">
            The book and services provided are devotional in nature. No refunds
            shall be issued once payment is completed.
          </p>
          <b className="text-gray-700 fs-6">3. Delivery Issues</b>
          <p className="mb-2 text-gray-600">
            The Trust is not responsible for delays or losses caused by courier
            services.
          </p>

          <b className="text-gray-700 fs-6">4. Duplicate Payments</b>
          <p className="mb-2 text-gray-600">
            In case of confirmed duplicate payments, the Trust may review and
            process a refund at its sole discretion.
          </p>

          <b className="text-gray-700 fs-6">5. Contact</b>
          <p className="text-gray-600">
            For queries, contact the Trust through the Website.
          </p>
        </div>
      </div>
      <ElementPage />
    </>
  );
}

const styles = {
  container: {
    maxWidth: "900px",
    margin: "40px auto",
    padding: "0 20px",
    lineHeight: "1.7",
  },
};
